// extracted by mini-css-extract-plugin
export default {"productItem":"ProductItemMoby_productItem__InvFA"};